import toast from 'react-hot-toast';

export const notifySaveSuccess = (): string => toast.success('保存しました');
export const notifySaveFailure = (): string =>
  toast.error('保存に失敗しました');
export const notifyClipboardCopySuccess = (): string =>
  toast.success('クリップボードにコピーをしました');
